import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GetEstadisticasSertecMensualesPorUsuarioEnAPI, GetEstadisticasMatriculasPorUsuarioDetalleEnAPI, GetEstadisticasTotalesAnnosEnAPI, GetEstadisticasMatriculasPorUsuarioEnAPI, EstadisticasSertecMensualesPorUsuarioCSVEnAPI } from "../../action/actionCreatorsRequests"
import { traducirPagina, convertirMoneda, redondeo, MSGOK, convertirAMesACodigo, obtenerFechaLocalObjeto, convertirCodigoAMeses, obtenerUsuario, descargarDocPasandoBase64Generico } from '../../librerias/funciones'
import { MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBDropdownMenu, MDBDropdown, MDBDropdownToggle, MDBDropdownItem } from 'mdbreact';
import FichaDetalleMatricula from '../../components/FichaDetalleMatricula';
import {
    BarChartOutlined,
    EyeOutlined,
    CloseOutlined,
    FileExcelOutlined,
    TableOutlined
} from '@ant-design/icons';

import { Select, Card, Modal, Button, Input, Row, Col, Drawer, Checkbox } from 'antd';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from "recharts";



const FichaEstadistica = ({ props, configApp, openDrawerFichaClienteSocio, clienteTallerSeleccionado }) => {
    const [TAB_SELECCIONADO, setTAB_SELECCIONADO] = React.useState("tab-1");
    const [hayRegristros, setHayRegristros] = React.useState(false);
    const [mesesDelAnio, setMesesDelAnio] = React.useState(
        [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ]
    );

    const [mesSeleccionado, setMesSeleccionado] = React.useState("")
    const [anios, setAnios] = React.useState([]);
    const [anioSeleccionado, setAnioSeleccionado] = React.useState("")

    const [seCambioElDia, setSeCambioElDia] = React.useState(true);
    const [seCambioElMes, setSeCambioElMes] = React.useState(false);
    const [seCambioElAnio, setSeCambioElAnio] = React.useState(false);

    const [estadisticasMatricula, setEstadisticasMatricula] = React.useState([]);

    const [estadisticasMatriculaDetalle, setEstadisticasMatriculaDetalle] = React.useState({});
    const [abrirDetalleMatricula, setAbrirDetalleMatricula] = React.useState(false);

    const [estadisticaMensuales, setEstadisticaMensuales] = React.useState([]);
    const [estadisticaSeleccionada, setEstadisticaSeleccionada] = React.useState({});
    const [fechaPartida, setFechaPartida] = React.useState({});

    const [registroGrafico, setRegistroGrafico] = React.useState([]);
    const [tipoGrafico, setTipoGrafico] = React.useState("GRAFICO");
    const [registroKeyGrafico, setRegistroKeyGrafico] = React.useState(
        [
            {
                NOMBRE: "DIAS CONECTADOS",
                ACTIVO: true
            },
            {
                NOMBRE: "PEDIDOS",
                ACTIVO: false
            },
            {
                NOMBRE: "BASTIDORES",
                ACTIVO: false
            },
            {
                NOMBRE: "MATRICULAS",
                ACTIVO: false
            },
            {
                NOMBRE: "VEHICULOS",
                ACTIVO: false
            },
            {
                NOMBRE: "REFERENCIAS",
                ACTIVO: false
            }
        ]
    );








    const buscarCondiciones = () => {
        let condiciones = { DESDE: "0", HASTA: "0" }
        if (seCambioElDia && !seCambioElMes && !seCambioElAnio) {
            condiciones.DESDE = "4"
            condiciones.HASTA = "5"
        } else if (!seCambioElDia && seCambioElMes && !seCambioElAnio) {
            condiciones.DESDE = "0"
            condiciones.HASTA = "1"
        } else if (!seCambioElDia && !seCambioElMes && seCambioElAnio) {
            condiciones.DESDE = "2"
            condiciones.HASTA = "3"
        }
        return condiciones;
    }


    const buscarEstadisticaMatricula = (ID_USUARIO_PLATAFORMA, codigoMes, Anio, condiciones, PLATAFORMA) => {
        setEstadisticasMatricula([])
        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = ""
        let TIPO_FECHA = "1"

        if (condiciones.DESDE === "4" && condiciones.HASTA === "5") {
            crearFecha = fechaLocal.DIA + "/" + codigoMes + "/" + Anio
            TIPO_FECHA = 1

        } else if (condiciones.DESDE === "0" && condiciones.HASTA === "1") {
            crearFecha = "01" + "/" + codigoMes + "/" + Anio
            TIPO_FECHA = 2

        } else if (condiciones.DESDE === "2" && condiciones.HASTA === "3") {
            crearFecha = "01" + "/" + "01" + "/" + Anio
            TIPO_FECHA = 3
        }

        setFechaPartida({ TIPO_FECHA: TIPO_FECHA, FECHA: TIPO_FECHA === 2 ? codigoMes : Anio })

        GetEstadisticasMatriculasPorUsuarioEnAPI(crearFecha, condiciones.DESDE, condiciones.HASTA, PLATAFORMA, ID_USUARIO_PLATAFORMA).then(registro => {
            if (registro !== undefined) {
                if (registro.REGISTROS !== undefined && registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
                    setEstadisticasMatricula(registro.REGISTROS)
                } else {
                    setEstadisticasMatricula(null)
                }

            }
        })
    }


    const buscarEstadisticaMatriculaDetalle = (ID_USUARIO_PLATAFORMA, codigoMes, Anio, condiciones, PLATAFORMA, CONSULTA) => {
        setEstadisticasMatriculaDetalle({})
        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = ""

        if (condiciones.DESDE === "4" && condiciones.HASTA === "5") {
            crearFecha = fechaLocal.DIA + "/" + fechaLocal.MES + "/" + Anio
        } else if (condiciones.DESDE === "0" && condiciones.HASTA === "1") {
            crearFecha = "01" + "/" + codigoMes + "/" + Anio
        } else if (condiciones.DESDE === "2" && condiciones.HASTA === "3") {
            crearFecha = "01" + "/" + "01" + "/" + Anio
        }

        GetEstadisticasMatriculasPorUsuarioDetalleEnAPI(crearFecha, condiciones.DESDE, condiciones.HASTA, PLATAFORMA, ID_USUARIO_PLATAFORMA, CONSULTA).then(registro => {
            if (registro !== undefined) {
                if (registro.REGISTROS !== undefined && registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
                    setEstadisticasMatriculaDetalle(registro)
                } else {
                    setEstadisticasMatriculaDetalle(null)
                }

            }
        })
    }

    const buscarAnios = (socio, codigoMes, Anio) => {
        let fechaLocal = obtenerFechaLocalObjeto(false);
        let crearFecha = fechaLocal.DIA + "/" + codigoMes + "/" + Anio


        GetEstadisticasTotalesAnnosEnAPI(crearFecha, "0", "0", socio).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setAnios(registros.REGISTROS)
            } else {
                setAnios(null)
                //setAnios([{ANYO:2022},{ANYO:2021}])
            }

        })
    }




    const EstadisticasSertecMensuales = (ID_USUARIO) => {
        const estadisticaMeses = []
        GetEstadisticasSertecMensualesPorUsuarioEnAPI(ID_USUARIO).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setEstadisticaMensuales(registros.REGISTROS)

                registros.REGISTROS.map((registro) => {
                    let mes = {
                        MES: registro.MES,
                        "DIAS CONECTADOS": registro.TOTAL_DIAS_CONECTADO_MES === "" ? 0 : parseInt(registro.TOTAL_DIAS_CONECTADO_MES),
                        PEDIDOS: registro.TOTAL_PEDIDOS === "" ? 0 : parseInt(registro.TOTAL_PEDIDOS),
                        BASTIDORES: registro.TOTAL_BASTIDORES === "" ? 0 : parseInt(registro.TOTAL_BASTIDORES),
                        MATRICULAS: registro.TOTAL_MATRICULAS === "" ? 0 : parseInt(registro.TOTAL_MATRICULAS),
                        VEHICULOS: registro.TOTAL_VEHICULOS === "" ? 0 : parseInt(registro.TOTAL_VEHICULOS),
                        REFERENCIAS: registro.TOTAL_REFERENCIAS === "" ? 0 : parseInt(registro.TOTAL_REFERENCIAS)
                    }
                    estadisticaMeses.push(mes)
                })

                setRegistroGrafico(estadisticaMeses)
            } else {
                setEstadisticaMensuales(null)
            }
        })

    }

    const EstadisticasSertecMensualesPorUsuarioCSV = (ID_USUARIO) => {
        EstadisticasSertecMensualesPorUsuarioCSVEnAPI(ID_USUARIO).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }

            }

        })

    }



    if (!hayRegristros && props.ESTADO_FICHA) {
        setHayRegristros(true);
        let accesoLicencia = obtenerUsuario();
        let fechaLocal = obtenerFechaLocalObjeto(false);
        setMesSeleccionado(convertirCodigoAMeses(fechaLocal.MES))
        setAnioSeleccionado(fechaLocal.ANIO)
        buscarEstadisticaMatricula(props.ID_USUARIO, fechaLocal.MES, fechaLocal.ANIO, buscarCondiciones(), "SERTEC")
        buscarAnios(props.SOCIO, fechaLocal.MES, fechaLocal.ANIO)

    } else {
        if (!props.ESTADO_FICHA && hayRegristros) {
            setTAB_SELECCIONADO("tab-1")
            setHayRegristros(false)
        }
    }




    return (
        <div>
            <Drawer
                width={"950px"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ESTADO_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>




                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>





                <div className="p-3" style={{ height: (configApp.height - 70).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>

                    <div style={{ color: '#333', fontSize: '18px', marginBottom: '20px' }}>
                        <span style={{ fontWeight: 'bold', color: '#999' }}>{`${traducirPagina("Usu_seleccionado")}: `}</span>
                        <br />
                        {props.USUARIO.NOMBRE_USUARIO}
                    </div>

                    <div className="tabs effect-3" style={{ color: '#000' }}>

                        <input type="radio" id="tab-1" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-1" ? "checked" : ""} />
                        <span onClick={(e) => { setTAB_SELECCIONADO("tab-1") }}>{traducirPagina("Matriculas").toUpperCase()}</span>

                        <input type="radio" id="tab-2" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-2" ? "checked" : ""} />
                        <span onClick={(e) => { setTAB_SELECCIONADO("tab-2"); EstadisticasSertecMensuales(props.ID_USUARIO) }}>{traducirPagina("Evolucion_uso")}</span>

                        <input type="radio" id="tab-3" name="tab-effect-3" checked={TAB_SELECCIONADO === "tab-3" ? "checked" : ""} />
                        <span onClick={(e) => { setTAB_SELECCIONADO("tab-3") }}>{traducirPagina("Otros")}</span>


                        <div className="line ease"></div>

                        <div className="tab-content">
                            <section id="tab-item-1">

                                <div style={{ color: '#000', fontSize: '20px', marginBottom: '20px' }}>
                                    {traducirPagina("Msg_estadistica_matricula")}
                                </div>

                                <div style={{ fontSize: '13px', fontWeight: '500', display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                                    <div style={{ width: '130px', padding: '7px', backgroundColor: seCambioElDia ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff' }} onClick={(e) => {
                                        let anioActual = obtenerFechaLocalObjeto(false).ANIO;
                                        setAnioSeleccionado(anioActual);

                                        setSeCambioElDia(true);
                                        setSeCambioElMes(false);
                                        setSeCambioElAnio(false);

                                        buscarEstadisticaMatricula(props.ID_USUARIO, obtenerFechaLocalObjeto(false).MES, anioActual, { DESDE: "4", HASTA: "5" }, "SERTEC")
                                    }}>{traducirPagina("Hoy")}</div>

                                    <div style={{ width: '130px' }}>
                                        <MDBDropdown>
                                            <MDBDropdownToggle nav>
                                                <div style={{ padding: '7px', backgroundColor: seCambioElMes ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginLeft: '10px', color: '#fff', width: '120px' }}>
                                                    {mesSeleccionado.toUpperCase()}
                                                </div>
                                            </MDBDropdownToggle>

                                            <MDBDropdownMenu right >
                                                {mesesDelAnio.map((mes, i) =>
                                                    <MDBDropdownItem key={i} onClick={(e) => {
                                                        setSeCambioElDia(false);
                                                        setSeCambioElAnio(false);
                                                        setMesSeleccionado(e.target.innerText);
                                                        buscarEstadisticaMatricula(props.ID_USUARIO, convertirAMesACodigo(e.target.innerText), anioSeleccionado, { DESDE: "0", HASTA: "1" }, "SERTEC")


                                                        setSeCambioElMes(true)
                                                    }}>  {mes.toUpperCase()}</MDBDropdownItem>
                                                )}
                                            </MDBDropdownMenu>
                                        </MDBDropdown>
                                    </div>
                                    <div style={{ width: '130px' }}>
                                        <MDBDropdown>
                                            <MDBDropdownToggle nav>
                                                <div style={{ padding: '7px', backgroundColor: seCambioElAnio ? '#007bff' : '#a2a2a2', fontSize: '16px', fontWeight: '500', marginLeft: '10px', color: '#fff', width: '120px' }}>
                                                    {anioSeleccionado}
                                                </div>
                                            </MDBDropdownToggle>


                                            <MDBDropdownMenu right >
                                                {anios !== null ?
                                                    anios.map((anio, i) =>
                                                        <MDBDropdownItem key={i} onClick={(e) => {
                                                            setSeCambioElDia(false);
                                                            setSeCambioElMes(false);
                                                            setAnioSeleccionado(e.target.innerText);
                                                            buscarEstadisticaMatricula(props.ID_USUARIO, convertirAMesACodigo(mesSeleccionado), e.target.innerText, { DESDE: "2", HASTA: "3" }, "SERTEC")

                                                            setSeCambioElAnio(true)
                                                        }}>  {anio.ANYO}</MDBDropdownItem>
                                                    )
                                                    :
                                                    null
                                                }
                                            </MDBDropdownMenu>
                                        </MDBDropdown>
                                    </div>
                                </div>


                                {estadisticasMatricula === null ?
                                    <div style={{ fontSize: '20px', fontWeight: '500' }}>{traducirPagina("Sin_resultados")} </div>
                                    :
                                    estadisticasMatricula.length > 0 ?
                                        <div style={{ backgroundColor: '#dcdcdc', padding: '20px' }}>
                                            <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
                                                <div style={{ width: '80%' }}>{traducirPagina("Consultas_realizadas")}</div>
                                                <div style={{ width: '15%', fontWeight: '500', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS, "")} </div>
                                                <div style={{ width: '8%', fontWeight: '500', textAlign: 'right' }}
                                                    onClick={() => {
                                                        if (estadisticasMatricula[0].TOTAL_CONSULTAS > 0) {
                                                            setAbrirDetalleMatricula(true)
                                                            buscarEstadisticaMatriculaDetalle(props.ID_USUARIO, convertirAMesACodigo(mesSeleccionado), anioSeleccionado, buscarCondiciones(), "SERTEC", "TODAS")

                                                            setEstadisticaSeleccionada({ TITULO: "TOTALES", TOTAL: convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS, "") })
                                                        }
                                                    }}
                                                >{<EyeOutlined style={{ fontSize: '25px', verticalAlign: 'baseline', cursor: 'pointer' }} />} </div>
                                            </div>



                                            <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
                                                <div style={{ width: '12%' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + "%"}</div>
                                                <div style={{ backgroundColor: '#f1f1f1', width: '37%' }}>
                                                    <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS_CIENTO + '%', height: '100%' }}></div>
                                                </div>
                                                <div style={{ width: '28%', textAlign: 'right' }}>{"OK "}</div>

                                                <div style={{ width: '15%', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS, "")}</div>

                                                <div style={{ width: '8%', fontWeight: '500', textAlign: 'right', color: estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS > 0 ? '#000' : '#999' }}
                                                    onClick={() => {
                                                        if (estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS > 0) {
                                                            setAbrirDetalleMatricula(true)
                                                            buscarEstadisticaMatriculaDetalle(props.ID_USUARIO, convertirAMesACodigo(mesSeleccionado), anioSeleccionado, buscarCondiciones(), "SERTEC", "OK")

                                                            setEstadisticaSeleccionada({ TITULO: "OK", TOTAL: convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_CORRECTAS, "") })
                                                        }
                                                    }}

                                                >{<EyeOutlined style={{ fontSize: '25px', verticalAlign: 'baseline', cursor: 'pointer' }} />} </div>

                                            </div>


                                            <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
                                                <div style={{ width: '12%' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES_CIENTO + "%"}</div>
                                                <div style={{ backgroundColor: '#f1f1f1', width: '37%' }}>
                                                    <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES_CIENTO + '%', height: '100%' }}></div>
                                                </div>
                                                <div style={{ width: '28%', textAlign: 'right' }}>{"KO "}</div>

                                                <div style={{ width: '15%', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES, "")}</div>
                                                <div style={{ width: '8%', fontWeight: '500', textAlign: 'right', color: estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES > 0 ? '#000' : '#999' }}
                                                    onClick={() => {
                                                        if (estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES > 0) {
                                                            setAbrirDetalleMatricula(true)
                                                            buscarEstadisticaMatriculaDetalle(props.ID_USUARIO, convertirAMesACodigo(mesSeleccionado), anioSeleccionado, buscarCondiciones(), "SERTEC", "KO")

                                                            setEstadisticaSeleccionada({ TITULO: "KO", TOTAL: convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_ERRORES, "") })

                                                        }
                                                    }}
                                                >{<EyeOutlined style={{ fontSize: '25px', verticalAlign: 'baseline', cursor: 'pointer' }} />} </div>

                                            </div>


                                            <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
                                                <div style={{ width: '12%' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + "%"}</div>
                                                <div style={{ backgroundColor: '#f1f1f1', width: '37%' }}>
                                                    <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS_CIENTO + '%', height: '100%' }}></div>
                                                </div>
                                                <div style={{ width: '28%', textAlign: 'right' }}>{traducirPagina("Cobradas").toUpperCase()}</div>

                                                <div style={{ width: '15%', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS, "")}</div>
                                                <div style={{ width: '8%', fontWeight: '500', textAlign: 'right', color: estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS > 0 ? '#000' : '#999' }}
                                                    onClick={() => {
                                                        if (estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS > 0) {
                                                            setAbrirDetalleMatricula(true)
                                                            buscarEstadisticaMatriculaDetalle(props.ID_USUARIO, convertirAMesACodigo(mesSeleccionado), anioSeleccionado, buscarCondiciones(), "SERTEC", "COBRADAS")

                                                            setEstadisticaSeleccionada({ TITULO: "COBRADAS", TOTAL: convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_COBRADAS, "") })

                                                        }
                                                    }}
                                                >{<EyeOutlined style={{ fontSize: '25px', verticalAlign: 'baseline', cursor: 'pointer' }} />} </div>

                                            </div>


                                            <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
                                                <div style={{ width: '12%' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + "%"}</div>
                                                <div style={{ backgroundColor: '#f1f1f1', width: '37%' }}>
                                                    <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_CIENTO + '%', height: '100%' }}></div>
                                                </div>
                                                <div style={{ width: '28%', textAlign: 'right' }}>{traducirPagina("Sin_cobrar")}</div>

                                                <div style={{ width: '15%', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR, "")}</div>
                                                <div style={{ width: '8%', fontWeight: '500', textAlign: 'right', color: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR > 0 ? '#000' : '#999' }}
                                                    onClick={() => {
                                                        if (estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR > 0) {
                                                            setAbrirDetalleMatricula(true)
                                                            buscarEstadisticaMatriculaDetalle(props.ID_USUARIO, convertirAMesACodigo(mesSeleccionado), anioSeleccionado, buscarCondiciones(), "SERTEC", "SIN_COBRAR")

                                                            setEstadisticaSeleccionada({ TITULO: "SIN COBRAR", TOTAL: convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_SIN_COBRAR, "") })
                                                        }
                                                    }}
                                                >{<EyeOutlined style={{ fontSize: '25px', verticalAlign: 'baseline', cursor: 'pointer' }} />} </div>

                                            </div>


                                            <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start' }}>
                                                <div style={{ width: '12%' }}>{estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + "%"}</div>
                                                <div style={{ backgroundColor: '#f1f1f1', width: '37%' }}>
                                                    <div style={{ backgroundColor: '#007bff', width: estadisticasMatricula[0].TOTAL_CONSULTAS_REPETIDAS_DIFERENTES_CIENTO + '%', height: '100%' }}></div>
                                                </div>
                                                <div style={{ width: '28%', textAlign: 'right' }}>{traducirPagina("Repeticiones")}</div>

                                                <div style={{ width: '15%', textAlign: 'right' }}>{convertirMoneda(estadisticasMatricula[0].TOTAL_CONSULTAS_MATRICULAS_REPETIDAS_SIN_COBRAR_DIFERENTES, "")}</div>
                                                <div style={{ width: '8%', fontWeight: '500', textAlign: 'right' }}>
                                                </div>
                                            </div>


                                        </div>
                                        :
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '30vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                }
                            </section>

                            <section id="tab-item-2">
                                <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', color: '#000' }}>
                                    <div style={{ textAlign: 'left' }}>   <button style={{ height: '40px', width: '120px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: tipoGrafico === "TABLA" ? '#dcdcdc' : '#efefef' }} onClick={(e) => { setTipoGrafico("TABLA") }}><TableOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Tabla")} </span>  </button> </div>

                                    <div style={{ textAlign: 'left', width: '65%' }}>     <button style={{ marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: tipoGrafico === "GRAFICO" ? '#dcdcdc' : '#efefef' }} onClick={(e) => { setTipoGrafico("GRAFICO") }}><BarChartOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Grafico")} </span>  </button></div>

                                    <div style={{ textAlign: 'right', display: tipoGrafico === "GRAFICO" ? 'none' : '' }}>
                                        <button style={{ width: '200px', marginLeft: '20px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticasSertecMensualesPorUsuarioCSV(props.ID_USUARIO) }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                                    </div>

                                </div>

                                {tipoGrafico === "GRAFICO" ?
                                    <div style={{ fontSize: '20px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start', marginBottom: '20px', color: '#000' }}>

                                        {registroKeyGrafico !== undefined || registroKeyGrafico !== null ?
                                            registroKeyGrafico.map((registro) =>
                                                <Checkbox checked={registro.ACTIVO}
                                                    onChange={(e) => {
                                                        registroKeyGrafico.map((item) => {
                                                            if (item.NOMBRE === registro.NOMBRE) {
                                                                item.ACTIVO = e.target.checked
                                                            }
                                                        }
                                                        )
                                                        setRegistroKeyGrafico([...registroKeyGrafico]);
                                                    }} ><span style={{ fontSize: '12px', fontWeight: '500', color: '#000' }}>{registro.NOMBRE}</span> </Checkbox>
                                            )
                                            :
                                            null
                                        }
                                    </div>
                                    :
                                    null
                                }


                                {tipoGrafico === "TABLA" ?
                                    estadisticaMensuales.length > 0 ?
                                        <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                            <thead>
                                                <tr style={{ backgroundColor: '#e0e0e0' }}>
                                                    <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Mes")}</th>
                                                    <th style={{ width: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => { }}>{traducirPagina("Conexiones")}</th>
                                                    <th style={{ width: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => { }}>{traducirPagina("Promedio")}</th>
                                                    <th style={{ width: '80px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Pedidos")}</th>
                                                    <th style={{ width: '150px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => { }}>{traducirPagina("Importe")}</th>
                                                    <th style={{ width: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => { }}>{traducirPagina("Bastidores")}</th>
                                                    <th style={{ width: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }} onClick={(e) => { }}>{traducirPagina("Matrículas")}</th>
                                                    <th style={{ width: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Vehiculos")}</th>
                                                    <th style={{ width: '90px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{traducirPagina("Referencias")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {estadisticaMensuales.map((registro, i) =>
                                                    <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.MES}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TOTAL_DIAS_CONECTADO_MES === "" ? 0 : registro.TOTAL_DIAS_CONECTADO_MES}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.PROMEDIO_CONEXION_MES === "" ? 0 : registro.PROMEDIO_CONEXION_MES}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TOTAL_PEDIDOS === "" ? 0 : registro.TOTAL_PEDIDOS}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{registro.MONTO_PEDIDOS === "" ? 0 : registro.MONTO_PEDIDOS}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TOTAL_BASTIDORES === "" ? 0 : registro.TOTAL_BASTIDORES}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TOTAL_MATRICULAS === "" ? 0 : registro.TOTAL_MATRICULAS}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TOTAL_VEHICULOS === "" ? 0 : registro.TOTAL_VEHICULOS}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'center' }}>{registro.TOTAL_REFERENCIAS === "" ? 0 : registro.TOTAL_REFERENCIAS}</td>
                                                    </tr>
                                                )
                                                }
                                            </tbody>
                                        </table>
                                        :
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                                    :

                                    registroGrafico.length > 0 ?
                                        <LineChart
                                            width={850}
                                            height={500}
                                            data={registroGrafico}
                                            margin={{
                                                top: 5,
                                                right: 30,
                                                left: 20,
                                                bottom: 5
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="MES" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />

                                            {registroKeyGrafico.filter((item) => item.NOMBRE === "DIAS CONECTADOS" && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey="DIAS CONECTADOS" stroke="#8884d8" /> : null}
                                            {registroKeyGrafico.filter((item) => item.NOMBRE === "PEDIDOS" && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey="PEDIDOS" stroke="#82ca9d" /> : null}
                                            {registroKeyGrafico.filter((item) => item.NOMBRE === "BASTIDORES" && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey="BASTIDORES" stroke="#6d3c11" /> : null}
                                            {registroKeyGrafico.filter((item) => item.NOMBRE === "MATRICULAS" && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey="MATRICULAS" stroke="#EB636B" /> : null}
                                            {registroKeyGrafico.filter((item) => item.NOMBRE === "VEHICULOS" && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey="VEHICULOS" stroke="#F197CD" /> : null}
                                            {registroKeyGrafico.filter((item) => item.NOMBRE === "REFERENCIAS" && item.ACTIVO).length > 0 ? <Line type="monotone" dataKey="REFERENCIAS" stroke="#FEC9A7" /> : null}


                                        </LineChart>
                                        :
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                }

                            </section>
                            <section id="tab-item-3">
                                <h1>Otros</h1>
                            </section>
                        </div>
                    </div>
                </div>
            </Drawer>


            {abrirDetalleMatricula ?
                <FichaDetalleMatricula
                    title={traducirPagina("Historial_matriculas")}
                    ESTADO_FICHA={abrirDetalleMatricula}
                    CERRAR_FICHA={setAbrirDetalleMatricula}
                    REGISTRO={estadisticasMatriculaDetalle}
                    USUARIO={props.USUARIO}
                    SELECCIONADO={estadisticaSeleccionada}
                    FECHA_PARTIDA={fechaPartida}
                >
                </FichaDetalleMatricula>
                :
                null
            }


        </div>
    )
}



FichaEstadistica.propTypes = {
    title: PropTypes.string,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_USUARIO: PropTypes.number,
    SOCIO: PropTypes.number,
    USUARIO: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado
    };
}

export default connect(mapStateToProps)(FichaEstadistica);